// extracted by mini-css-extract-plugin
export default {"wrapper":"Ip-z","reviewFormSuccess":"Jp-z","header":"Kp-z","message":"Lp-z","paragraph":"Mp-z","lottieContainer":"Np-z"};